import { animate, onScroll, createTimeline, stagger } from 'animejs';
import globalVar from '../utils/globalVar'
import utils from '../utils/utils'


class ScrollAnime {
  constructor() {
    let cache = {};
    let initFunc = () => {
      initCache();
      initAnime();
    }

    let initCache = () => {
        // COMPONENTS
        cache.animeParallaxImg = document.querySelectorAll('.anime-parallax_img img');
        cache.animeTitre = document.querySelectorAll('.anime-titre');
        cache.animeTitreH1 = document.querySelectorAll('.anime-titre-h1');
        cache.animeOpacity = document.querySelectorAll('.anime-opacity');
        cache.animeFullOpacity = document.querySelectorAll('.anime-full-opacity');
        cache.animeBtn = document.querySelectorAll('.anime-btn');
        cache.animeTexte = document.querySelectorAll('.anime-texte');
        cache.animeTexteHero = document.querySelectorAll('.anime-texte-hero');
        cache.animeBgShape = document.querySelectorAll('.anime-bg-shape');
        cache.animeBgDraw = document.querySelectorAll('.anime-bg-draw');
        cache.animeLogo = document.querySelectorAll('.anime-logo');
        cache.animeLogoFooter = document.querySelector('footer .logo');

        // MODULE
        cache.module03Paragraphe = document.querySelectorAll('.module-03-paragraphe');
        cache.module07Etapes = document.querySelectorAll('.module-07-etapes');
        cache.module08Avantages = document.querySelectorAll('.module-08-avantages');
        cache.module09Mosaique = document.querySelectorAll('.module-09-mosaique');
        cache.module10Services = document.querySelectorAll('.module-10-services');
        cache.module11Articles = document.querySelectorAll('.module-11-articles');
        cache.module15Contact = document.querySelectorAll('.module-15-contact');

        // TEMPLATES
        cache.templateArchiveBlog = document.querySelector('.template-archive-blog');
        cache.templateArchiveServices = document.querySelector('.template-archive-services');
        cache.templateSingleServices = document.querySelector('.template-single-services');
        
    };

    let initAnime = () => {
        // COMPONENTS

        // IMAGES
        if(cache.animeParallaxImg) {
            cache.animeParallaxImg.forEach((animeParallaxImg) => {
                const container = animeParallaxImg.closest('section');
                animate(animeParallaxImg, {
                    x: ['-50%', '-50%'],
                    y: ['-42%', '-58%'],
                    duration: 2000,
                    ease: 'linear',
                    autoplay: onScroll({
                      target: container,
                      axis: 'y',
                      enter: { container: 'bottom' },
                      leave: { container: 'top' },
                      sync: 0.25,
                    })
                  });
            });
        }

        // TITRE
        if(cache.animeTitre) {
            cache.animeTitre.forEach((animeTitre) => {
                animate(animeTitre, {
                    opacity: [0.3, 1],
                    duration: 2000,
                    ease: 'linear',
                    autoplay: onScroll({
                      target: animeTitre.closest('section'),
                      axis: 'y',
                      enter: { container: 'bottom' },
                      leave: '75% 160',
                      sync: 0.25,
                    })
                  });
            });
        }

        // TITRE H1
        if(cache.animeTitreH1) {
            cache.animeTitreH1.forEach((animeTitreH1) => {
                animate(animeTitreH1.querySelectorAll('.title-h1'), {
                    opacity: [0, 1],
                    translateY: ["100%", "0%"],
                    duration: 2000,
                    ease: 'linear',
                    autoplay: onScroll({
                      target: animeTitreH1.closest('section'),
                      axis: 'y',
                      enter: { container: 'bottom' },
                      leave: '75% 160',
                      sync: 0.25,
                    })
                  });
            });
        }

        // OPACITY
        if(cache.animeOpacity) {
            cache.animeOpacity.forEach((animeOpacity) => {
                animate(animeOpacity, {
                    opacity: [0.3, 1],
                    duration: 2000,
                    ease: 'linear',
                    autoplay: onScroll({
                      target: animeOpacity,
                      axis: 'y',
                      enter: { container: 'bottom' },
                      leave: '75% 160',
                      sync: 0.25,
                    })
                  });
            });
        }

        // FULL OPACITY
        if(cache.animeFullOpacity) {
            cache.animeFullOpacity.forEach((animeFullOpacity) => {
                animate(animeFullOpacity, {
                    opacity: [0, 1],
                    duration: 2000,
                    ease: 'linear',
                    autoplay: onScroll({
                      target: animeFullOpacity,
                      axis: 'y',
                      enter: { container: 'bottom' },
                      leave: '75% 160',
                      sync: 0.25,
                    })
                  });
            });
        }

        // TEXTE
        if(cache.animeTexte) {
            cache.animeTexte.forEach((animeTexte) => {
                animate(animeTexte, {
                    opacity: [0.3, 1],
                    lineHeight: ['200%', '150%'],
                    duration: 2000,
                    ease: 'linear',
                    autoplay: onScroll({
                      target: animeTexte,
                      axis: 'y',
                      enter: { container: 'bottom' },
                      leave: '75% 140',
                      sync: 0.25,
                    })
                  });
            });
        }

        // TEXTE HERO
        if(cache.animeTexteHero) {
            cache.animeTexteHero.forEach((animeTexteHero) => {
                animate(animeTexteHero, {
                    opacity: [0, 1],
                    lineHeight: ['200%', '150%'],
                    duration: 600,
                    ease: 'outSine',
                    delay: 300,
                  });
            });
        }

        // BTN
        if(cache.animeBtn) {
            cache.animeBtn.forEach((animeBtn) => {
                animate(animeBtn, {
                    opacity: [0.3, 1],
                    scale: [1.05, 1],
                    duration: 2000,
                    ease: 'linear',
                    autoplay: onScroll({
                      target: animeBtn,
                      axis: 'y',
                      enter: { container: 'bottom' },
                      leave: '75% 100',
                      sync: 0.25,
                    })
                  });
            });
        }

        // BG SHAPE
        if(cache.animeBgShape) {
            cache.animeBgShape.forEach((animeBgShape) => {
                animate(animeBgShape, {
                    scale: [1.55, 1],
                    translateY: ["25%", "0%"],
                    duration: 2000,
                    ease: 'linear',
                    autoplay: onScroll({
                      target: animeBgShape.closest('section'),
                      axis: 'y',
                      enter: { container: 'bottom' },
                      leave: '75% 200',
                      sync: 0.25,
                    })
                  });
            });
        }

        // BG DRAW
        if(cache.animeBgDraw) {
            cache.animeBgDraw.forEach((animeBgDraw) => {
                
                if(globalVar.tablet.matches) {
                    const tl = createTimeline({
                        defaults: { 
                            duration: 2000,
                            ease: 'linear',
                        },
                        autoplay: onScroll({
                            target: animeBgDraw.closest('section'),
                            axis: 'y',
                            enter: { container: 'bottom' },
                            leave: '50% 50%',
                            sync: 0.25,
                        })
                    });

                    tl.add(animeBgDraw.querySelector('.rect_2'), {
                        y: ["0%", "100%"],
                        duration: 500,
                    }, 500)
                    .add(animeBgDraw.querySelector('.rect_3'), {
                        y: ["0%", "-100%"],
                        x: ["0%", "100%"],
                        rotate: [20, 20],
                        duration: 500,
                    }, '<-=235');

                } else {
                    const tl = createTimeline({
                        defaults: { 
                            duration: 2000,
                            ease: 'linear',
                        },
                        autoplay: onScroll({
                            target: animeBgDraw.closest('section'),
                            axis: 'y',
                            enter: { container: 'bottom' },
                            leave: '50% 50%',
                            sync: 0.25,
                        })
                    });

                    tl.add(animeBgDraw.querySelector('.rect_1'), {
                        y: ["0%", "-100%"],
                        x: ["0%", "150%"],
                        rotate: [24, 24],
                        duration: 500,
                    }, 500)
                    .add(animeBgDraw.querySelector('.rect_2'), {
                        y: ["0%", "100%"],
                        duration: 500,
                    }, '<-=235')
                    .add(animeBgDraw.querySelector('.rect_3'), {
                        y: ["0%", "-100%"],
                        x: ["0%", "100%"],
                        rotate: [27, 27],
                        duration: 500,
                    }, '<-=150');
                }
                
            });
        }

        // LOGO
        if(cache.animeLogo) {
            cache.animeLogo.forEach((animeLogo) => {
                animate(animeLogo.querySelectorAll('svg path'), {
                    opacity: [0, 1],
                    translateY: ["200%", "0%"],
                    ease: 'outSine',
                    delay: stagger(50),
                    duration: stagger(50, { start: 800 }),
                  });
            });
        }

        // LOGO FOOTER
        if(cache.animeLogoFooter) {
            const sections = document.querySelectorAll('section');
            const lastSection = sections[sections.length - 1];
            animate(cache.animeLogoFooter.querySelectorAll('svg path'), {
                opacity: [0, 1],
                translateY: ["200%", "0%"],
                ease: 'outSine',
                delay: stagger(50),
                duration: stagger(100, { start: 800 }),
                autoplay: onScroll({
                    target: lastSection,
                    axis: 'y',
                    enter: { container: 'top' },
                    leave: '0% 65%',
                    sync: true,
                })
            });
        }




        // MODULE

        // MODULE 03 - PARAGRAPHE
        cache.module03Paragraphe.forEach((module03Paragraphe) => {
            const txt = module03Paragraphe.querySelector('.txt_container p');
            if (txt) {
                const textNodes = Array.from(txt.childNodes);
                txt.innerHTML = '';
                
                textNodes.forEach(node => {
                    if (node.nodeType === Node.TEXT_NODE) {
                        const letters = node.textContent.split('');
                        letters.forEach(letter => {
                            const span = document.createElement('span');
                            span.textContent = letter;
                            txt.appendChild(span);
                        });
                    } else if (node.nodeType === Node.ELEMENT_NODE && (node.tagName === 'A' || node.tagName === 'SUP')) {
                        const clone = node.cloneNode(true);
                        
                        const linkText = clone.textContent;
                        clone.textContent = '';
                            
                        linkText.split('').forEach(letter => {
                            const span = document.createElement('span');
                            span.textContent = letter;
                            clone.appendChild(span);
                        });
                    
                        txt.appendChild(clone);
                    }
                });
                
                animate(txt.querySelectorAll('span'), {
                    opacity: [0, 1],
                    duration: 800,
                    delay: stagger(15),
                    easing: 'easeOutQuad',
                    autoplay: onScroll({
                        target: module03Paragraphe,
                        axis: 'y',
                        enter: { container: 'center' },
                        leave: '50% 75%',
                        sync: 0.25,
                    })
                });
            }
        });

        // MODULE 07 - ÉTAPE
        cache.module07Etapes.forEach((module07Etapes) => {
            const steps = module07Etapes.querySelectorAll('.step');
            const squares = module07Etapes.querySelectorAll('.square');
            for (let i = 0; i < squares.length; i++) {
                const square = squares[i];
                const step = steps[i];
                animate(square, {
                    scale: [
                        { to: 1.25, duration: 300},
                        { to: 1, duration: 500}
                    ],
                    duration: 800,
                    ease: 'outSine',
                    autoplay: onScroll({
                        target: step,
                        enter: '356 0',
                        leave: '356 100',
                        sync: 0.25,
                    })
                });
            }
        });

        // MODULE 08 - AVANTAGES
        cache.module08Avantages.forEach((module08Avantages) => {
            const row = module08Avantages.querySelectorAll('.avantage');
            animate(row, {
                paddingTop: [140, 40],
                delay: stagger(100),
                duration: stagger(200, { start: 500 }),
                autoplay: onScroll({
                    target: row,
                    axis: 'y',
                    enter: { container: 'bottom' },
                    leave: { container: 'top' },
                    sync: 0.25,
                })
            });
        });
        // MODULE 09 - MOSAIQUE
        cache.module09Mosaique.forEach((module09Mosaique) => {
            const row = module09Mosaique.querySelectorAll('.mosaique_row');
            row.forEach((row) => {
                const box = row.querySelectorAll('.mosaique_box');
                const shuffledBoxes = shuffle(Array.from(box));
                
                if(globalVar.tablet.matches) {
                    box.forEach((box) => {
                        animate(box, {
                            scale: [0.8, 1],
                            opacity: [0, 1],
                            duration: 500,
                            autoplay: onScroll({
                                target: box,
                                enter: '70%',
                            })
                        });
                    });
                } else {
                    animate(shuffledBoxes, {
                        scale: [0.8, 1],
                        opacity: [0, 1],
                        delay: stagger(100),
                        duration: stagger(200, { start: 500 }),
                        autoplay: onScroll({
                            target: row,
                            enter: '70%',
                        })
                    });
                }
            });
        });

        // MODULE 10 - SERVICES
        cache.module10Services.forEach((module10Services) => {
            const row1 = module10Services.querySelector('.services_row.row1');
            const row2 = module10Services.querySelector('.services_row.row2');
            const services = module10Services.querySelector('.services');

            if(globalVar.tablet.matches) {
                animate(services, {
                    x: ['80%', '0%'],
                    duration: 2000,
                    ease: 'linear',
                    autoplay: onScroll({
                    target: module10Services,
                    axis: 'y',
                    enter: { container: 'bottom' },
                    leave: (window.innerHeight * 1.5),
                    sync: 0.25,
                    })
                });
                const serviceMobile = module10Services.querySelectorAll('.service_card');
                serviceMobile.forEach((serviceMobile) => {
                    animate(serviceMobile, {
                        opacity: [0.6, 1],
                        duration: 800,
                        delay: stagger(15),
                        easing: 'easeOutQuad',
                        autoplay: onScroll({
                            target: serviceMobile,
                            container: module10Services.querySelector('.services'),
                            axis: 'x',
                            enter: { container: 'right' },
                            leave: '75% 50%',
                            sync: 0.25,
                            onSyncComplete: () => {
                                const iconMobileAnime = serviceMobile.querySelector('.icon dotlottie-player');
                                if(iconMobileAnime) {
                                    iconMobileAnime.stop()
                                    iconMobileAnime.play()
                                }
                            },
                        })
                    });
                });
            } else {
                animate(row1, {
                    x: ['80%', '0%'],
                    duration: 2000,
                    ease: 'linear',
                    autoplay: onScroll({
                    target: module10Services,
                    axis: 'y',
                    enter: { container: 'bottom' },
                    leave: (window.innerHeight * 1.5),
                    sync: 0.25,
                    onSyncComplete: () => {
                        const iconMobileAnime = row1.querySelectorAll('.icon dotlottie-player');
                        for (let i = 0; i < iconMobileAnime.length; i++) {
                            setTimeout(() => {
                                iconMobileAnime[i].stop()
                                iconMobileAnime[i].play()
                            }, i * 200);
                        }
                    },
                    })
                });
                animate(row2, {
                    x: ['-80%', '0%'],
                    duration: 2000,
                    ease: 'linear',
                    autoplay: onScroll({
                    target: module10Services,
                    axis: 'y',
                    enter: { container: 'bottom' },
                    leave: (window.innerHeight * 1.5),
                    sync: 0.25,
                    onSyncComplete: () => {
                        const iconMobileAnime = row2.querySelectorAll('.icon dotlottie-player');
                        for (let i = 0; i < iconMobileAnime.length; i++) {
                            setTimeout(() => {
                                iconMobileAnime[i].stop()
                                iconMobileAnime[i].play()
                            }, i * 200);
                        }
                    },  
                    })
                });
            }
            
        });

        // MODULE 11 - ARTICLES
        cache.module11Articles.forEach((module11Articles) => {
            const articles = module11Articles.querySelectorAll('.article');
            const articlesReversed = Array.from(articles).reverse();
            if(globalVar.tablet.matches) {
                animate(articles, {
                    opacity: [0, 1],
                    y: [80, 0],
                    ease: 'outSine',
                    duration: 600,
                    autoplay: onScroll({
                    target: module11Articles,
                    axis: 'y',
                    enter: { container: 'bottom' },
                    leave: '75% 50%',
                    sync: 0.25,

                })
            });
            } else {
                animate(articlesReversed, {
                    opacity: [0, 1],
                    y: [80, 0],
                    ease: 'outSine',
                    duration: 600,
                    delay: stagger(200),
                    autoplay: onScroll({
                    target: module11Articles,
                    axis: 'y',
                    enter: { container: 'bottom' },
                    leave: '50% 50%',
                    sync: 0.25,
                })
            });
            }
        });

        // MODULE 15 - CONTACT
        cache.module15Contact.forEach((module15Contact) => {
            const block1 = module15Contact.querySelector('.contact_cta1');
            const block2 = module15Contact.querySelector('.contact_cta2');

            if(globalVar.tablet.matches) {
                animate(block1, {
                    x: ['-5%', '5%'],
                    duration: 2000,
                    ease: 'linear',
                    autoplay: onScroll({
                    target: module15Contact,
                    axis: 'y',
                    enter: { container: 'bottom' },
                    leave: { container: 'top' },
                    sync: 0.25,
                    })
                });
                
                animate(block2, {
                    x: ['5%', '-5%'],
                    duration: 2000,
                    ease: 'linear',
                    autoplay: onScroll({
                    target: module15Contact,
                    axis: 'y',
                    enter: { container: 'bottom' },
                    leave: { container: 'top' },
                    sync: 0.25,
                    })
                });
            } else {
                animate(block1, {
                    y: ['-15%', '15%'],
                    duration: 2000,
                    ease: 'linear',
                    autoplay: onScroll({
                    target: module15Contact,
                    axis: 'y',
                    enter: { container: 'bottom' },
                    leave: { container: 'top' },
                    sync: 0.25,
                    })
                });
                
                animate(block2, {
                    y: ['15%', '-15%'],
                    duration: 2000,
                    ease: 'linear',
                    autoplay: onScroll({
                    target: module15Contact,
                    axis: 'y',
                    enter: { container: 'bottom' },
                    leave: { container: 'top' },
                    sync: 0.25,
                    })
                });
            }
        });

        //TEMPLATES

        //TEMPLATE ARCHIVE BLOG
        if(cache.templateArchiveBlog) {
            const featureArticle = cache.templateArchiveBlog.querySelector('.feature_article');
            const sections = cache.templateArchiveBlog.querySelectorAll('.module_articles');
            if(featureArticle) {
                animate(featureArticle, {
                    opacity: [0, 1],
                    y: [80, 0],
                    ease: 'outSine',
                    duration: 800,
                });
            }
            for(let i = 0; i < sections.length; i++) {
                const articles = sections[i].querySelectorAll('.article');
                let articlesArray = articles;
                if(i % 2 == 0) {
                    articlesArray = Array.from(articles).reverse();   
                }
                
                    if(globalVar.tablet.matches) {
                        animate(articles[i], {
                            opacity: [0, 1],
                            y: [80, 0],
                            ease: 'outSine',
                            duration: 600,
                            autoplay: onScroll({
                            target: articles[i],
                            axis: 'y',
                            enter: { container: 'bottom' },
                            leave: '75% 50%',
                            sync: 0.25,
                        })
                    });
                    } else {
                        animate(articlesArray, {
                            opacity: [0, 1],
                            y: [80, 0],
                            ease: 'outSine',
                            duration: 600,
                            delay: stagger(200),
                            autoplay: onScroll({
                            target: sections[i],
                            axis: 'y',
                            enter: { container: 'bottom' },
                            leave: '50% 50%',
                        })
                    });
                    }
            };
        }

        //TEMPLATE ARCHIVE SERVICES
        if(cache.templateArchiveServices) {
            const services = cache.templateArchiveServices.querySelectorAll('.services_container .service');
            if(services) {
                services.forEach((service) => {
                    const icon = service.querySelector('.service_inner .icon');
                    const iconAnime = icon.querySelector('dotlottie-player');
                    animate(service, {
                        y: [80, 0],
                        ease: 'outSine',
                        duration: 600,
                        autoplay: onScroll({
                            target: service,
                            axis: 'y',
                            enter: { container: 'bottom' },
                            leave: '75% 50%',
                            sync: 0.25,
                        })
                    });
                    animate(service.querySelector('.service_inner'), {
                        y: [80, 0],
                        opacity: [0, 1],
                        ease: 'outSine',
                        duration: 600,
                        autoplay: onScroll({
                            target: service,
                            axis: 'y',
                            enter: { container: 'bottom' },
                            leave: '75% 50%',
                            sync: 0.25,
                        })
                    });
                    animate(icon, {
                        rotate: [-40, 0],
                        scale: [0.5, 1],
                        ease: 'outSine',
                        duration: 600,
                        autoplay: onScroll({
                            target: icon,
                            axis: 'y',
                            enter: { container: 'bottom' },
                            leave: '75% 50%',
                            sync: 0.25,
                            onSyncComplete: () => {
                                if(iconAnime){
                                    iconAnime.stop()
                                    iconAnime.play()
                                }
                            },
                        })
                    });
                });
            }
        }


        // SINGLE SERVICES
        if(cache.templateSingleServices) {
            const icon = document.querySelector('.hero_container .icon');
            const iconAnime = icon.querySelector('dotlottie-player');
            animate(icon, {
                opacity: [0, 1],
                scale: [0.5, 1],
                ease: 'outSine',
                duration: 1000,
                autoplay: onScroll({
                    target: icon,
                    axis: 'y',
                    enter: { container: 'bottom' },
                    leave: '70% 50%',
                    sync: 0.25,
                    onSyncComplete: () => {
                        if(iconAnime){
                            iconAnime.stop()
                            iconAnime.play()
                        }
                    },
                })
            });

            const iconMobile = document.querySelector('.hero_container .icon_mobile');
            const iconMobileAnime = iconMobile.querySelector('dotlottie-player');
            animate(iconMobile, {
                opacity: [0, 1],
                scale: [0.5, 1],
                ease: 'outSine',
                duration: 1000,
                autoplay: onScroll({
                    target: iconMobile,
                    axis: 'y',
                    enter: { container: 'bottom' },
                    leave: '70% 50%',
                    sync: 0.25,
                    onSyncComplete: () => {
                        if(iconMobileAnime){
                            iconMobileAnime.stop()
                            iconMobileAnime.play()
                        }
                    },
                })
            });

            const txt = document.querySelector('.hero_service .txt p');
            if (txt) {
                const textNodes = Array.from(txt.childNodes);
                console.log(textNodes);
                txt.innerHTML = '';
                
                textNodes.forEach(node => {
                    if (node.nodeType === Node.TEXT_NODE) {
                        const letters = node.textContent.split('');
                        letters.forEach(letter => {
                            const span = document.createElement('span');
                            span.textContent = letter;
                            txt.appendChild(span);
                        });
                    } else if (node.nodeType === Node.ELEMENT_NODE && (node.tagName === 'A' || node.tagName === 'SUP')) {
                        const clone = node.cloneNode(true);
                        
                        const linkText = clone.textContent;
                        clone.textContent = '';
                            
                        linkText.split('').forEach(letter => {
                            const span = document.createElement('span');
                            span.textContent = letter;
                            clone.appendChild(span);
                        });
                    
                        txt.appendChild(clone);
                    }
                });
                
                animate(txt.querySelectorAll('span'), {
                    opacity: [0, 1],
                    duration: 800,
                    delay: stagger(15),
                    easing: 'easeOutQuad',
                    autoplay: onScroll({
                        target: document.querySelector('.hero_service'),
                        axis: 'y',
                        enter: { container: 'center' },
                        leave: '50% 75%',
                        sync: 0.25,
                    })
                });
            }
        }
    };


    function shuffle(array) {
        for (let i = array.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [array[i], array[j]] = [array[j], array[i]];
        }
        return array;
    }

    initFunc();
  };
}
export { ScrollAnime }